<template>
  <td
    :title="$bct(statusTitle)"
    class="bb-1 py-2 br-1 bc-very-light-grey"
  >
    <div
      @click="handleClick"
      :class="classes"
      :data-testId="`day-${isClickable ? 'clickable' : 'not-clickable'}`"
      :style="styles"
      class="rounded d-flex align-center justify-center h-100pc"
    >
      {{ $bct(code) }}
    </div>
  </td>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  day: {
    type: Number,
    default: null,
  },
  invalid: {
    type: Boolean,
    default: false,
  },
  log: {
    type: Object,
    default: null,
  },
  operatingLog: {
    type: Object,
    default: null,
  },
  queue: {
    type: Array,
    default: null,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  statuses: {
    type: Array,
    default: null,
  },
  operatingStatuses: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click']);

const logDay = computed(() => `day_${props.day}`);

const code = computed(() => props.log[logDay.value]);

const isClickable = computed(() => open.value && !props.readonly && !queued.value);

const queued = computed(
  () => !!props.queue.find((ac) => ac.log.id === props.log.id && ac.day === props.day),
);

const open = computed(() => {
  const dayCode = props.operatingLog[logDay.value];
  if (dayCode) {
    const operatingStatus = props.operatingStatuses.find(
      (operatingStatus) => operatingStatus.code === dayCode,
    );
    return operatingStatus ? !operatingStatus.closed : false;
  }
  return false;
});

const status = computed(() => props.statuses.find((status) => status.code === code.value));

const classes = computed(() => {
  const ary = [];
  if (!props.log[logDay.value]) {
    ary.push('bg-very-light-grey');
  }

  if (queued.value) {
    ary.push('shadowed');
  }

  if (open.value && !props.readonly) {
    ary.push('pointer');
  }

  return ary.join(' ');
});

const styles = computed(() => {
  let styles = '';
  if (status.value) {
    styles += `background-color: ${status.value.color}`;
  }
  if (props.invalid) {
    styles += ' border: 2px solid #B30036';
  }
  return styles;
});

const statusTitle = computed(() => {
  if (status.value) return status.value.title;
  return 'unknown';
});

const handleClick = () => {
  if (isClickable.value) {
    emit('click');
  }
};
</script>
